import Modal from "PFComponents/modal/modal";
import React, { useEffect } from "react";

import { useSkillManagementModal } from "../../../table/hooks/use_skill_management_modal";
import { ImportModalPage } from "./constants/import_modal_page";
import {
  ImportSkillsModalContextProvider,
  useImportSkillsModalContext
} from "./contexts/import_skills_modal_context";
import css from "./import_skills_modal.module.scss";
import { ImportDataTablePage } from "./parts/import_data_table_page";
import { ImportErrorPage } from "./parts/import_error_page";
import { ImportHistoryPage } from "./parts/import_history_page";
import { ImportModalFooter } from "./parts/import_modal_footer";
import { ImportModalHeader } from "./parts/import_modal_header";
import { ImportSuccessPage } from "./parts/import_success_page";
import { UploadPage } from "./parts/upload_page";

// handleClose is automatically passed to content by Modal to allow animation on close
const ImportSkillsModalContent = ({ handleClose }: { handleClose?: VoidFunction }): JSX.Element => {
  const { setCurrentPage, currentPage, importData } = useImportSkillsModalContext();

  useEffect(() => {
    if (currentPage === ImportModalPage.ImportDataTable && !importData) {
      setCurrentPage(ImportModalPage.Upload);
    }
  }, [currentPage, setCurrentPage, importData]);

  return (
    <div className={css.modalContent}>
      <ImportModalHeader handleClose={handleClose} />
      <div className={css.mainContent}>
        {currentPage === ImportModalPage.Upload && <UploadPage />}
        {currentPage === ImportModalPage.ImportSuccess && <ImportSuccessPage />}
        {currentPage === ImportModalPage.ImportError && <ImportErrorPage />}
        {currentPage === ImportModalPage.ImportHistory && <ImportHistoryPage />}
        {currentPage === ImportModalPage.ImportDataTable && importData && (
          <ImportDataTablePage importData={importData} />
        )}
      </div>
      <ImportModalFooter handleClose={handleClose} />
    </div>
  );
};

export const ImportSkillsModal = ({ initialPage }: { initialPage?: ImportModalPage }): JSX.Element => {
  const { closeModal } = useSkillManagementModal();

  return (
    <ImportSkillsModalContextProvider initialPage={initialPage}>
      {/* @ts-ignore */}
      <Modal
        handleClose={closeModal}
        classes={{
          modal: css.modal,
          dialog: css.dialog
        }}
      >
        <ImportSkillsModalContent />
      </Modal>
    </ImportSkillsModalContextProvider>
  );
};
